import type { RouteRecordRaw } from 'vue-router'

export const REPAIR = {
  TRACKING: 'repair_tracking',
}

const routes: readonly RouteRecordRaw[] = [
  {
    path: '/:locale/dashboard/repair/:repairId',
    name: REPAIR.TRACKING,
    component: () => null,
    meta: {
      auth: {
        required: true,
      },
      disableClientSideNavigation: () => true,
      keepHash: true,
    },
  },
]

export default routes
